import { observer } from 'mobx-react';
import { isNotBlank } from '@roc/feature-utils';

import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'
import { useParams } from 'react-router';
import { DecodedParams } from 'libs/client-portal-shared/src/app/modules/creditBackground/stores/requestCreditAuthStore';
import { CAF } from 'libs/feature-borrowers/src/caf/caf';

export const PublicCAF = observer(() => {
  const { encodedParams } = useParams<{ encodedParams: string }>();
  // Security review MED-005: URL params are untrusted. Decode defensively so a
  // malformed value can't crash the page. Server-side authorization on the
  // referenced ids is still required.
  let decodedParams: DecodedParams = {} as DecodedParams;
  try {
    const decodedParamsString = isNotBlank(encodedParams) ? atob(encodedParams) : '{}';
    decodedParams = JSON.parse(decodedParamsString);
  } catch {
    decodedParams = {} as DecodedParams;
  }
  return <CAF decodedParams={decodedParams} />;
});